module.exports = __webpack_public_path__ + "static/media/window-frame-open.be0fc1ea.svg";